// extracted by mini-css-extract-plugin
export default {"popoverTitle":"popoverTitle___HhOYO","rules":"rules___0rwU8"};